import React from 'react';
import FormPage from '../shared/FormPage';
import useCreateCompanyStore from '../../stores/createCompanyStore';

import { BUSINESS_TYPES } from "./businessTypes";
export { BUSINESS_TYPES } from "./businessTypes";

const CompanyNamePage = () => {
  const { formData, setFormData, isStepValid, nextStep, previousStep } = useCreateCompanyStore();
  
  const handleChange = (value) => {
    setFormData('companyName', value);
  };
  return (
    <FormPage
      title="What's your company name?"
      subtitle="This will be displayed across your account and sets the onboarding defaults for your business."
      inputType="text"
      placeholder="Enter your company name"
      value={formData.companyName}
      onChange={handleChange}
      onNext={nextStep}
      onPrevious={previousStep}
      isValid={isStepValid(1)}
    >
      <div>
        <div className="mb-4 text-left">
          <p className="text-sm font-medium text-gray-900">Business type</p>
          <p className="mt-1 text-sm text-gray-600">
            Choose the operating model you want Rightwork to use for default departments and onboarding recommendations.
          </p>
        </div>
        <div className="space-y-3">
          {BUSINESS_TYPES.map((option) => (
            <button
              key={option.value}
              onClick={() => setFormData('businessType', option.value)}
              className={`w-full rounded-3xl border-2 p-5 text-left transition-all ${
                formData.businessType === option.value
                  ? 'border-violet-700 bg-violet-50'
                  : 'border-slate-200 bg-white hover:border-violet-200 hover:bg-violet-50/40'
              }`}
            >
              <p className="text-lg text-slate-900">{option.title}</p>
              <p className="mt-2 text-sm text-slate-600">{option.description}</p>
            </button>
          ))}
        </div>
      </div>
    </FormPage>
  );
};

export default CompanyNamePage;
